<div class="p-4 mt-5">
    <div *ngIf="!producto.cargando">
        <img class="img-producto mw-100" *ngIf="producto.imagenes.length == 0" src="/assets/img/producto-sin-imagen.svg">
        <owl-carousel-o *ngIf="producto.imagenes.length > 0" [options]="customOptions">
            <ng-container *ngFor="let imagen of producto.imagenes">
                <ng-template carouselSlide>
                    <img [src]="imagen.med" />
                </ng-template>
            </ng-container>
        </owl-carousel-o>
        <div>
            <strong>${{ producto.precio_final_con_impuesto_format }}</strong>&nbsp;&nbsp;&nbsp;
            <strong *ngIf="globals.configuracion.front.typeabbrev == '02' && producto.precio_unico == 0 && producto.precio_mayor != 0"><s>${{ producto.precio_detal_con_impuesto_format }}</s></strong>
        </div>
        <!--
        <div *ngIf="globals.configuracion.front.typeabbrev == '02' && producto.precio_unico == 0 && producto.precio_mayor != 0">
            <strong><s>${{ producto.precio_detal_con_impuesto_format }}</s></strong>
        </div>
        -->
		<form [formGroup]="form">
            <div class="grid-cantidad">
                <div class="row m-0">
                    <div class="col ps-0 pe-1">
                    </div>
                    <div class="lbl-cantidad col px-0">
                        Cantidad
                    </div>
                    <div class="col pe-0 ps-1">
                    </div>
                </div>
                <div class="row m-0">
                    <div class="col ps-0 pe-1">
                        <button type="button" class="cursor-pointer" (click)="disminuirCantidad()">
                            <mat-icon>remove</mat-icon>
                        </button>
                    </div>
                    <div class="col px-0">
                        <input type="number" min="1" #cantidad formControlName="cantidad" (input)="inputEvent(cantidad.value)">
                    </div>
                    <div class="col pe-0 ps-1">
                        <button type="button" class="cursor-pointer" (click)="incrementarCantidad()">
                            <mat-icon>add</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
        </form>
        <h4 class="text-center my-1">Total</h4>
        <h2 class="text-center my-0">{{ producto.total }}</h2>
    </div>
    <div align="center">
        <mat-spinner *ngIf="formComportamiento.enviando" diameter="20" class="me-3"></mat-spinner>
        <button mat-raised-button color="primary" class="wide mt-2 green" (click)="agregarProducto()" >Agregar</button>
        <!--<button mat-raised-button color="primary" (click)="agregarProductoCotizar()" [disabled]="!form.valid || formComportamiento.enviando">Agregar y Cotizar</button>-->
        <button mat-raised-button color="accent" class="wide mt-2" (click)="seCerro()" >Volver</button>
    </div>
   
    <div *ngIf="producto.tags.length > 0" class="box-tags d-flex flex-wrap mt-4">
        
        <div class="flex-grow-1">
            <span class="tag-producto" *ngFor="let tag of producto.tags | slice:0:5">{{ tag.modeldescrip }}</span>
            <ng-container *ngIf="producto.tags.length > 5">
                <span class="tag-producto" [matMenuTriggerFor]="moreTags" (click)="masTags($event)">...</span>
                <mat-menu #moreTags="matMenu">
                    <button *ngFor="let tag of producto.tags | slice:5" mat-menu-item>{{ tag.modeldescrip }}</button>
                </mat-menu>
            </ng-container>
        </div>
        
    </div>
    <div class="detalle" *ngIf="producto.detalle" [innerHTML]='producto.detalle'>
    </div>
</div>